export default __webpack_public_path__ + "static/media/icon-upload-fill.cfc40be6.svg";